import * as rice from './rice'

/**
 * C 端已经全部走 rice。`server.dao`(xiangjiandao-core / .NET)刻意不再挂在
 * 这里 —— rice 的登录不签发 daoJwt,任何遗漏的 core 调用都会在运行期
 * 401,而不是在编译期被发现。想调 core 只能显式 import,以示这是个例外。
 *
 * `src/server/dao/` 目录还留着:`defineProxyAPI` 被 post 服务复用,
 * 管理端(60 个接口)也还没迁。
 */
const server = {
  rice,
}

export default server
